export const TWG_CLI_URL = '/cli';
export const TWG_MCP_URL = '/mcp';
export const TWG_CLI_DOCS_URL = 'https://developer.atlassian.com/cloud/twg-cli/';
export const TWG_CLI_INSTALLATION_URL =
	'https://developer.atlassian.com/cloud/twg-cli/getting-started/installation/';
export const TWG_MCP_CONNECT_URL =
	'https://support.atlassian.com/atlassian-ai-gateway/docs/authentication-and-authorization/';
export const TWG_MCP_EXAMPLES_URL =
	'https://support.atlassian.com/atlassian-ai-gateway/docs/use-atlassian-rovo-mcp-server/';
export const TWG_MCP_CHANGELOG_URL = 'https://developer.atlassian.com/cloud/rovo-mcp/changelog/';
export const ROVO_CONNECTORS_URL = 'https://www.atlassian.com/software/rovo/connectors';
export const TWG_BENCHMARK_WAITLIST_URL =
	'https://www.atlassian.com/platform/teamwork-graph/context-quality-benchmarking-waitlist';
// Direct access to Teamwork Graph; linked from the nav bar's sign-up dialog.
export const TWG_WAITLIST_URL = 'https://www.atlassian.com/platform/teamwork-graph/waitlist';

/**
 * Up-to improvement in answer quality, in percent, that agents showed with
 * Teamwork Graph context in internal testing. Shown on the home page benchmark
 * section's "improvement in quality" metric.
 */
export const BENCHMARK_QUALITY_IMPROVEMENT_PERCENT = 44;

/**
 * Up-to reduction in tokens used, in percent, that agents showed with Teamwork
 * Graph context in internal testing. Shown on the home page benchmark section's
 * "fewer tokens" metric.
 */
export const BENCHMARK_FEWER_TOKENS_PERCENT = 48;

/**
 * Destinations for the CLI page's "Get started" section. These resolve against
 * the `platform/teamwork-graph` documentation tree rather than the shorter
 * `cloud/twg-cli` aliases used by the constants above.
 */
const TWG_CLI_PLATFORM_DOCS_URL = 'https://developer.atlassian.com/platform/teamwork-graph/twg-cli';

export const TWG_CLI_INSTALL_GUIDE_URL: string = `${TWG_CLI_PLATFORM_DOCS_URL}/getting-started/installation/`;
export const TWG_CLI_AUTHENTICATION_URL: string = `${TWG_CLI_PLATFORM_DOCS_URL}/getting-started/configure-oauth/`;
export const TWG_CLI_AGENT_SKILLS_URL: string = `${TWG_CLI_PLATFORM_DOCS_URL}/agents/skills/`;
export const TWG_CLI_AGENT_EXAMPLES_URL: string = `${TWG_CLI_PLATFORM_DOCS_URL}/agents/examples/`;
export const TWG_CLI_CHANGELOG_URL: string = `${TWG_CLI_PLATFORM_DOCS_URL}/changelog/`;

/** Microsite root, which introduces the Teamwork Graph itself. */
export const TWG_MICROSITE_HOME_URL = '/';
